import { Components } from 'react-markdown';
import { Link } from 'src/general/components/Link/Link';
import { getLinkType } from 'src/general/helpers/getLinkType';
import styles from './Markdown.module.scss';

export const MarkdownLink: Components['a'] = ({ children, href, node, ...props }) => {
  const linkType = getLinkType(href ?? '/');

  // Custom overwrite for external links
  if (linkType === 'external' && typeof props.target === 'undefined') {
    props.target = '_blank';
    props.rel = 'noopener noreferrer';
  }

  return (
    <Link className={styles.link} href={href ?? '/'} {...props}>
      {Array.isArray(children) ? children[0] : children}
    </Link>
  );
};

export const MarkdownLinkBlank: Components['a'] = ({ children, href, node, ...props }) => (
  <Link className={styles.link} href={href ?? '/'} target="_blank" {...props}>
    {Array.isArray(children) ? children[0] : children}
  </Link>
);
